const createEFTFromFileStyle = {
};

export default createEFTFromFileStyle;
